import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AppSwitch from './Routes/AppSwitch';
import AuthSwitch from './Routes/AuthSwitch';
import { __getUserCredential } from './store/actions/login_action';
import ErrorBoundary from './ErrorBoundary';

const loadingPanel = (
  <div className="k-loading-mask Display_loadiing">
    <span className="k-loading-text">Loading</span>
    <div className="k-loading-image" />
    <div className="k-loading-color" />
  </div>
);

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: !!window.localStorage.getItem('token'),
      hasError: false
    };
  }

  /* Esta é a primeira etapa após o construxctor para carregar este componente  */

  componentDidMount() {
    window.localStorage.setItem('vpn', 1);
    if (!window.localStorage.getItem('username')) {
      window.localStorage.setItem('username', 'test');
    }
    if (!window.localStorage.getItem('Local')) {
      window.localStorage.setItem('Local', '');
    }
  }

  /*  Para renderizar o conteúdo html da página   */
  render() {
    return (

      <div>
        {this.state.isLoggedIn ? <ErrorBoundary><AppSwitch /></ErrorBoundary> : <AuthSwitch />}
        {loadingPanel}
      </div>

    );
  }
}

const mapStateToProps = ({ login }) => ({
  ...login
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    __getUserCredential
  },
  dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(App);
